import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import RequestAccessInfoImage from "../../assets/images/RequestAccessInfoModal.png";
import { SpaceCompactItemContext } from "antd/es/space/Compact";

const DatasetDetailsInfoModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-title">
        {"AAD Group Names"}
      </DialogTitle>
      <DialogContent>
        <Box mt={2}>
          {/* <Typography variant="h6" align="center">
            Maestro - Unified In-House Data and Analytics Platform
          </Typography> */}
          <p style={{ fontSize: "1rem" }}>
            <span>Note: </span> For few AAD group names in Publish storage layer, we have noticed two nomenclature used in Saviynt, Publish & Pub. If you are unable to find any Publish layer AAD group in Saviynt, try replacing "Publish" with "Pub" in the string and search.
          </p>
          <br></br>
          <p style={{ fontSize: "1rem" }}>
            e.g. <span>mlitbi_adl_ds_publish_idd (DEV) RO</span> —> <span>mlitbi_adl_ds_pub_idd (DEV) RO</span>
          </p>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DatasetDetailsInfoModal;
